import {createAction, props} from '@ngrx/store';

// BCH-533622 - Save product filter state for batch page
export const setProductFilter = createAction(
  '[ProductFilter] Set Product Filter',
  props<{
    projectId: string;
    selectedProductIds: number[] // BCH-533622 - changed from selectedProducts: string[]
  }>()
);

export const clearProductFilter = createAction(
  '[ProductFilter] Clear Product Filter',
  props<{ projectId: string }>()
);
